import Vue from 'vue';

Vue.filter('eventGuestState', (value) => {
  switch (value) {
    case 0:
      return 'Ausstehend';
    case 70:
      return 'Angenommen';
    case 99:
      return 'Abgelehnt';
    default:
      return value;
  }
});
